// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4470":"f5fbfd601a357ce6","4721":"f456e4a648764657","6345":"dda2eb0570bb97e5","6643":"82588921b13efcb7"}[chunkId] + ".js";
};